import React from 'react'

import ChildrenRepliesSection from './replies/ChildrenRepliesSection'
import Page from '../../../components/pdf/Page'
import RepliesSection from './replies/RepliesSection'
import { usePdfOptionsForm } from '../../../components/pdf/options/_form/PdfOptionsFormHandler'
import DocumentHeader from '../../serviceOrders/pdf/general/documentHeader/DocumentHeader'
import Overview from '../../serviceOrders/pdf/general/Overview'
import ServiceOrderHeader from '../../serviceOrders/pdf/general/ServiceOrderHeader'

const PdfDocument = ({ serviceOrder, categories, counters, childrenServiceOrders }) => {
  const form = usePdfOptionsForm()
  return (
    <Page>
      <DocumentHeader />
      <ServiceOrderHeader serviceOrder={serviceOrder} counters={counters} />
      <Overview serviceOrder={serviceOrder} />
      <RepliesSection serviceOrder={serviceOrder} categories={categories} />
      {!form.hideChildrenServiceOrders &&
        childrenServiceOrders.map(serviceOrder => (
          <ChildrenRepliesSection key={serviceOrder.id} serviceOrder={serviceOrder} />
        ))}
    </Page>
  )
}

export default PdfDocument
